<template>
	<div>
		<Navbar :navbarTitle="navbarTitle" :navBackLink="navBackLink">
			<template #bar>
				<slot name="bar"></slot>
			</template>
		</Navbar>
		<div class="main bg-00dp" :class="{ 'main-fixed': mainFixed }">
			<!-- <PageHeader :pageTitle="pageTitle" :pageSubtitle="pageSubtitle">
                <template #cta ><slot name="cta"></slot></template>
            </PageHeader> -->

			<Loader :show="loading"></Loader>
			<slot v-if="!loading"></slot>
		</div>
	</div>
</template>
<script>
import Navbar from "@/components/layout/Navbar"
import Loader from "@/components/layout/Loader"
import PageHeader from "@/components/layout/PageHeader"

export default {
	name: "Layout",
	props: ["loading", "navbarTitle", "pageTitle", "pageSubtitle", "navBackLink", "mainFixed"],
	components: {
		Navbar,
		Loader,
		PageHeader
	}
}
</script>

<style scoped>
.main {
	width: 100%;
	min-height: 100vh;
	display: flex;
	padding-top: 58px;
	flex-direction: column;
}
.main.main-fixed {
	width: 100%;
	height: 100%;
	position: fixed;
}
.main-container {
	padding: 18px;
}
layout {
	flex-grow: 1;
}
</style>
